import Navigation from '../../components/feature/Navigation';
import Footer from '../../components/feature/Footer';
import { useState } from 'react';

export default function Travel() {
  const [selectedStory, setSelectedStory] = useState<number | null>(null);
  const [activeCategory, setActiveCategory] = useState<string>('All');

  const destinations = [
    {
      name: '뷰 갤러리',
      description: '주변 경관과 휴식을 함께 할 수 있는 휴게공간',
      image: 'https://static.readdy.ai/image/ba36a1534eff85bb13d578944b3dbf04/b9ccbeaa77fb02dffdf0f607f737a86b.png',
      category: '파고라',
      story: 'My journey to Santorini was nothing short of magical. Arriving by ferry as the sun began its descent, I was immediately captivated by the iconic blue-domed churches perched on clifftops. The three days I spent here were filled with wandering through narrow cobblestone streets, discovering hidden cafes with the most incredible views, and of course, witnessing some of the most spectacular sunsets I\'ve ever seen. The locals were incredibly warm and welcoming, sharing stories of their island\'s volcanic history over glasses of local Assyrtiko wine. I spent hours in Oia, sketching the traditional architecture and collecting postcards for my scrapbook. The highlight was a boat trip around the caldera, where I learned about the island\'s fascinating geological formation. Every corner of Santorini offered a new photo opportunity, and my camera was constantly in hand. The contrast between the bright white buildings and the deep blue sea created the perfect backdrop for my travel journal entries.'
    },
    {
      name: '공원 안내판',
      description: '안내 목적별 콘텐츠의 구성 (이용수칙 및 시설 소개)',
      image: 'https://static.readdy.ai/image/ba36a1534eff85bb13d578944b3dbf04/11ba6675ecd19c4ee7ceec15b44f7513.png',
      category: '안내판',
      story: 'Kyoto during cherry blossom season was a dream come true. I timed my visit perfectly for early April when the sakura were in full bloom. Walking through the Philosopher\'s Path at dawn, with pink petals gently falling like snow, felt like stepping into a living painting. I spent entire days exploring ancient temples like Kinkaku-ji (the Golden Pavilion) and Fushimi Inari with its thousands of vermillion torii gates. The traditional tea ceremony I participated in taught me about the Japanese concept of mindfulness and presence. I stayed in a traditional ryokan where I learned the art of origami from the elderly owner, who became like a grandmother to me. My travel journal from this trip is filled with pressed cherry blossoms and detailed sketches of temple architecture. The contrast between ancient traditions and modern life in Kyoto fascinated me, and I documented this beautifully in my scrapbook with ticket stubs from temple visits, handwritten recipes from local restaurants, and photos of the incredible street art I discovered in the Gion district.'
    },
    {
      name: '마스코트 조형물',
      description: '지역/단지 스토리를 반영한 맞춤 디자인 및 설치',
      image: 'https://static.readdy.ai/image/ba36a1534eff85bb13d578944b3dbf04/c911f4a6b1f59c0d6ca9f9a3025cce17.png',
      category: '조형물',
      story: 'The trek to Machu Picchu was one of the most challenging yet rewarding experiences of my life. I chose the classic 4-day Inca Trail, camping under star-filled skies and waking up to breathtaking mountain vistas. Our guide, Carlos, shared fascinating stories about Inca culture and pointed out medicinal plants along the trail. The moment I first glimpsed Machu Picchu through the Sun Gate at sunrise, I actually cried - it was so overwhelming and beautiful. The ancient engineering marvels and the mystery surrounding this lost city left me speechless. I spent hours sketching the intricate stonework and terraces, trying to capture the play of light and shadow on the ancient walls. The llamas wandering through the ruins added a whimsical touch to my photos. In Cusco afterwards, I learned traditional weaving techniques from local artisans and bought beautiful textiles for my craft projects back home. This adventure pushed me out of my comfort zone and taught me so much about perseverance and the incredible achievements of ancient civilizations.'
    },
    {
      name: '위치 안내판',
      description: '현재 위치 기반 안내 및 아이콘 표기',
      image: 'https://static.readdy.ai/image/ba36a1534eff85bb13d578944b3dbf04/f871329c9a079190322ec2e1021f184c.png',
      category: '안내판',
      story: 'Bali captured my heart with its perfect blend of natural beauty and rich culture. I spent two weeks exploring everything from the iconic rice terraces in Jatiluwih to the artistic village of Ubud. The Balinese people\'s devotion to their Hindu traditions was evident everywhere - from the daily offerings placed outside homes to the elaborate temple ceremonies I was privileged to witness. I took a traditional batik painting class in Ubud, learning this ancient art form from a master craftsman whose family had been practicing for generations. The colors and patterns I learned became inspiration for my own craft projects. Sunrise at Mount Batur was absolutely magical - hiking in the dark to reach the summit just as the sun painted the sky in brilliant oranges and pinks. The volcanic landscape created the most dramatic backdrop for my photography. I also spent time learning to cook traditional Indonesian dishes, and my travel journal is filled with spice market visits and handwritten recipes. The spiritual energy of Bali was palpable, and I found myself slowing down and appreciating each moment more deeply.'
    },
    {
      name: '파고라 테이블 세트',
      description: '그늘과 테이블을 동시에 구성한 휴게시설',
      image: 'https://static.readdy.ai/image/ba36a1534eff85bb13d578944b3dbf04/37880d3a39b056baa5c8a47d5cc32ad5.png',
      category: '파고라',
      story: 'Iceland in winter was like visiting another planet. The dramatic landscapes, from thundering waterfalls to black sand beaches, provided endless inspiration for my photography and art. I\'ll never forget my first glimpse of the Northern Lights - dancing green ribbons across the star-filled sky near Lake Jökulsárlón. I spent three nights camping (yes, in winter!) to maximize my chances of seeing the aurora, and it was absolutely worth the cold fingers and toes. The Blue Lagoon\'s milky blue geothermal waters provided a surreal contrast to the volcanic landscape surrounding it. I collected unique black sand and volcanic rocks for my craft projects, each piece telling a story of this geologically active island. The Icelandic people I met were incredibly resilient and proud of their unique culture - I learned about their Viking heritage and modern literary traditions. My favorite discovery was a small village where I learned traditional Nordic knitting techniques from local women, creating a beautiful wool scarf that I still treasure. The raw, untamed beauty of Iceland challenged me as a photographer and artist, pushing me to capture the essence of this incredible landscape in my travel journals.'
    },
    {
      name: '2단 자전거 보관대',
      description: '거치와 보관을 정돈해 공동 공간의 질서와 편의성 향상',
      image: 'https://static.readdy.ai/image/ba36a1534eff85bb13d578944b3dbf04/99f31fc7597124c3ee95f273519e7673.png',
      category: '자전거 보관대',
      story: 'Morocco was a feast for all my senses. The vibrant souks of Marrakech overwhelmed me with their riot of colors, sounds, and smells - saffron, cinnamon, leather, and rose petals creating an intoxicating atmosphere. I spent days getting wonderfully lost in the maze-like medina, discovering hidden riads and traditional crafts workshops. Learning to haggle became an art form, and I collected beautiful ceramics, textiles, and spices for my projects back home. The three-day camel trek into the Sahara Desert was transformative - sleeping under a canopy of stars in the complete silence of the dunes gave me a new perspective on life\'s simple pleasures. Our Berber guides shared stories around the campfire and taught me traditional songs. The colors of the desert - from golden sand to deep blue twilight skies - inspired a whole new palette for my art. In Fez, I visited traditional tanneries and pottery workshops, documenting these ancient crafts in my journal with detailed sketches and notes. The geometric patterns in Islamic architecture fascinated me, and I spent hours studying and sketching the intricate tilework in mosques and palaces. Morocco challenged my preconceptions and opened my eyes to a completely different way of life.'
    },
    {
      name: '그랜드 파고라',
      description: '넓은 그늘을 한 번에 확보해 집객과 휴식을 동시에',
      image: 'https://static.readdy.ai/image/ba36a1534eff85bb13d578944b3dbf04/d3317df4178eef488877473386316c97.png',
      category: '파고라',
      story: 'The Swiss Alps offered an unforgettable experience of pristine natural beauty. Hiking through alpine meadows filled with wildflowers while surrounded by towering snow-capped peaks was truly magical. The traditional wooden chalets and the sound of cowbells in the distance created a fairytale atmosphere that I will cherish forever.'
    },
    {
      name: '전체 안내판',
      description: '장소에 대한 정보를 한 눈에 볼 수 있는 길찾기 포인트',
      image: 'https://static.readdy.ai/image/ba36a1534eff85bb13d578944b3dbf04/28586d56234d6ae7d4ddfe9d8a40c39d.png',
      category: '안내판',
      story: 'The Maldives was pure paradise on earth. Waking up in an overwater villa with the turquoise ocean beneath my feet was surreal. Snorkeling among vibrant coral reefs and swimming with manta rays created memories that will last a lifetime. The stunning sunsets painted the sky in shades of orange and pink every evening.'
    },
    {
      name: '벽천',
      description: '흐르는 물결로 공간에 고급스러움을 더하는 수경 시설',
      image: 'https://static.readdy.ai/image/ba36a1534eff85bb13d578944b3dbf04/34c06d0b15879569e8111f4683049d0f.png',
      category: '조형물',
      story: 'Patagonia\'s raw, untamed beauty left me speechless. Trekking to the base of the Torres del Paine towers and witnessing the massive Perito Moreno glacier calving into the lake were experiences of pure awe. The wind-swept landscapes and dramatic skies made every moment feel like an adventure.'
    },
    {
      name: '파고라',
      description: '햇빛과 비를 막아주는 그늘 쉼터',
      image: 'https://static.readdy.ai/image/ba36a1534eff85bb13d578944b3dbf04/df24ef225600b8be8108878247fe52a5.png',
      category: '파고라',
      story: 'The Amalfi Coast was a feast for the senses. Driving along the winding coastal roads with breathtaking views at every turn, stopping in charming villages like Positano and Ravello, and savoring fresh limoncello made from local lemons - every moment was pure Italian magic.'
    },
    {
      name: '1단 자전거 보관대',
      description: '거치와 보관을 정돈해 공동 공간의 질서와 편의성 향상',
      image: 'https://static.readdy.ai/image/ba36a1534eff85bb13d578944b3dbf04/f3ed60fa4bd02f239ac71ad7a6c8e5f9.png',
      category: '자전거 보관대',
      story: 'Witnessing the great migration in the Serengeti was a bucket-list experience come true. Seeing lions, elephants, and zebras in their natural habitat, camping under the African stars, and listening to the sounds of the savanna at night created an unforgettable connection with nature.'
    },
    {
      name: '펜스',
      description: '경계를 구분하여 공간의 완성도를 높이는 안전 포인트',
      image: 'https://static.readdy.ai/image/ba36a1534eff85bb13d578944b3dbf04/40d8ab5f11ae4a144521a087a23d8283.png',
      category: '기타',
      story: '야외 벤치 의자는 공원, 광장, 학교 등 다양한 야외 공간에 설치되는 제품입니다. 내구성이 뛰어난 소재를 사용하여 오랜 기간 사용이 가능하며, 세련된 디자인으로 공간의 미관을 높여줍니다.'
    },
    {
      name: '운동기구',
      description: '누구나 쉽게 건강 관리를 할 수 있는 체력 공간',
      image: 'https://static.readdy.ai/image/ba36a1534eff85bb13d578944b3dbf04/c5d32aea3238bff90b49ddfc85d182bc.png',
      category: '기타',
      story: '등받이 휴게 의자는 인체공학적 설계로 장시간 앉아도 편안한 제품입니다. 공원, 버스 정류장, 산책로 등 다양한 장소에 설치되며, 방문객들에게 쾌적한 휴식 공간을 제공합니다.'
    },
    {
      name: '플랜터',
      description: '내구성 있는 소재로 제작된 야외 공간용 다목적 테이블',
      image: 'https://static.readdy.ai/image/ba36a1534eff85bb13d578944b3dbf04/a4f0dbfc4f8fdec4a997e802f5d9d4ad.png',
      category: '기타',
      story: '야외 테이블은 공원, 캠핑장, 학교 운동장 등 다양한 야외 공간에 설치되는 제품입니다. 방수 및 내부식 처리된 소재를 사용하여 사계절 내구성이 뛰어나며, 가족 단위 방문객들이 편안하게 식사하거나 휴식을 취할 수 있도록 설계되었습니다.'
    },
    {
      name: '조형 테이블',
      description: '기능에 디자인을 더해 공간을 부각 시키는 시각 포인트',
      image: 'https://static.readdy.ai/image/ba36a1534eff85bb13d578944b3dbf04/f5a22dc94e4b4e040964f3783a31c3c5.png',
      category: '기타',
      story: '야외 쉼터는 공원, 광장, 학교 등 다양한 공공 공간에 설치되어 방문객들에게 비와 햇빛을 피할 수 있는 편안한 공간을 제공합니다. 내구성 있는 철재 프레임과 방수 지붕 소재를 사용하여 사계절 내내 안정적으로 사용할 수 있으며, 세련된 디자인으로 공간의 미관을 높여줍니다.'
    },
    {
      name: '포토존',
      description: '사진 한 장으로 추억을 만드는 조형공간',
      image: 'https://static.readdy.ai/image/ba36a1534eff85bb13d578944b3dbf04/1df8294ba815055cacb78b8b82412842.png',
      category: '조형물',
      story: 'Queenstown lived up to its reputation as the adventure capital of the world. From bungee jumping to jet boating, every day brought new thrills. But it was the serene beauty of Lake Wakatipu and the surrounding mountains that truly captured my heart and filled my travel journal with sketches.'
    },
    {
      name: '경관 조명',
      description: '야간 동선과 공간 분위기를 동시에 살리는 연출 포인트',
      image: 'https://static.readdy.ai/image/ba36a1534eff85bb13d578944b3dbf04/d90163b1d66afe373fd854e79b82f017.png',
      category: '조형물',
      story: '경관 조형물은 공원, 광장, 아파트 단지 등 다양한 공공 공간에 설치되어 공간의 개성과 예술적 가치를 높여주는 제품입니다. 친환경 소재와 내구성 있는 마감 처리로 사계절 내내 아름다운 경관을 유지하며, 방문객들에게 특별한 경험을 선사합니다.'
    }
  ];

  const categories = ['All', ...Array.from(new Set(destinations.map(d => d.category)))];

  const filteredDestinations = activeCategory === 'All'
    ? destinations
    : destinations.filter(d => d.category === activeCategory);

  const handleStoryClick = (index: number) => {
    setSelectedStory(index);
  };

  const closeStoryPopup = () => {
    setSelectedStory(null);
  };

  return (
    <div className="min-h-screen bg-gradient-to-br from-emerald-50 to-teal-50">
      <Navigation />
      
      {/* Hero Section */}
      <section 
        className="pt-20 md:pt-24 pb-12 md:pb-16 px-4 md:px-8 relative"
        style={{
          backgroundImage: `url('https://public.readdy.ai/ai/img_res/d2b7200b1cd2a71c7a5ae8625f040a2c.jpg')`,
          backgroundSize: 'cover',
          backgroundPosition: 'center'
        }}
      >
        <div className="absolute inset-0 bg-gradient-to-r from-emerald-500/70 to-teal-500/70"></div>
        <div className="relative z-10 max-w-4xl mx-auto text-center text-white">
          <h1 className="text-3xl md:text-6xl font-bold mb-4 md:mb-6 drop-shadow-2xl">제품 소개</h1>
          <p className="text-base md:text-2xl mb-6 md:mb-8 drop-shadow-lg px-2">
            단순한 설치가 아닌, 지속적인 사용을 고려한 제품을 제작합니다.
          </p>
        </div>
      </section>
      
      {/* Destinations Grid */}
      <section className="py-10 md:py-16 px-4 md:px-8 bg-white">
        <div className="max-w-7xl mx-auto">
          <h2 className="text-2xl md:text-4xl font-bold text-center text-gray-800 mb-8 md:mb-12">제품 목록 자세히 보기</h2>

          {/* Category Filter */}
          <div className="flex flex-wrap justify-center gap-2 md:gap-3 mb-8 md:mb-12">
            {categories.map((cat) => (
              <button
                key={cat}
                onClick={() => setActiveCategory(cat)}
                className={`whitespace-nowrap cursor-pointer px-4 md:px-6 py-2 rounded-full text-sm md:text-base font-medium transition-all duration-300 border-2 ${
                  activeCategory === cat
                    ? 'bg-emerald-500 border-emerald-500 text-white shadow-md scale-105'
                    : 'bg-white border-gray-200 text-gray-600 hover:border-emerald-400 hover:text-emerald-500'
                }`}
              >
                {cat === 'All' ? '전체' : cat}
              </button>
            ))}
          </div>

          {/* Result Count */}
          <p className="text-center text-sm text-gray-400 mb-6 -mt-4">
            {filteredDestinations.length}개의 제품
          </p>
          
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 md:gap-8">
            {filteredDestinations.map((destination) => {
              const index = destinations.indexOf(destination);
              return (
              <div 
                key={index}
                className="bg-white rounded-2xl overflow-hidden shadow-lg hover:shadow-2xl transition-all duration-500 transform hover:-translate-y-2"
              >
                {/* Image Area */}
                <div 
                  className="relative overflow-hidden"
                  style={{ height: '220px' }}
                >
                  <img
                    src={destination.image}
                    alt={destination.name}
                    className="w-full h-full object-cover object-top transition-transform duration-500 hover:scale-105"
                  />
                  <div className="absolute top-3 md:top-4 left-3 md:left-4">
                    <span className="bg-white/90 backdrop-blur-sm px-2 md:px-3 py-1 rounded-full text-xs md:text-sm font-medium text-gray-700">
                      {destination.category}
                    </span>
                  </div>
                </div>

                <div className="p-4 md:p-6">
                  <h3 className="text-lg md:text-xl font-bold text-gray-800 mb-2">{destination.name}</h3>
                  <p className="text-sm md:text-base text-gray-600 mb-4">{destination.description}</p>
                  
                  <div className="flex items-center gap-2">
                    <button
                      onClick={() => handleStoryClick(index)}
                      className="whitespace-nowrap cursor-pointer transition-all duration-300 font-medium rounded-full border-2 border-emerald-300 text-emerald-500 hover:bg-emerald-300 hover:text-white px-4 py-2 text-xs md:text-sm"
                    >
                      자세히 보기
                    </button>
                  </div>
                </div>
              </div>
              );
            })}
          </div>
        </div>
      </section>

      {/* Story Popup */}
      {selectedStory !== null && (
        <div className="fixed inset-0 bg-black/50 z-50 flex items-center justify-center p-4" onClick={closeStoryPopup}>
          <div className="bg-white rounded-2xl max-w-4xl w-full shadow-2xl" onClick={(e) => e.stopPropagation()}>
            <div className="flex justify-between items-center p-4 md:p-6 border-b border-gray-200">
              <h3 className="text-xl md:text-2xl font-bold text-gray-800">{destinations[selectedStory].name}</h3>
              <button 
                onClick={closeStoryPopup}
                className="w-8 h-8 bg-gray-100 rounded-full flex items-center justify-center hover:bg-gray-200 transition-colors cursor-pointer"
              >
                <i className="ri-close-line text-gray-600 text-xl"></i>
              </button>
            </div>
            <div className="p-4 md:p-8 overflow-y-auto max-h-[80vh]">
              <div 
                className="h-80 md:h-[500px] bg-cover bg-center rounded-xl"
                style={{ backgroundImage: `url('${destinations[selectedStory].image}')` }}
              ></div>
            </div>
          </div>
        </div>
      )}
      
      <Footer />
    </div>
  );
}
